import { ModalContext } from "app/app";
import { FieldInput } from "components/fieldInput";
import { Icon } from "components/lib";
import { Form, Formik } from "formik";
import { Fragment, useContext, useState } from "react";
import * as Yup from "yup";
import Loader from "./images/loader.gif";
import styles from "./styles.module.scss";

export function VideoModal(props) {
  const { modal, setModal } = useContext(ModalContext);
  const [loading, setLoading] = useState(false);

  const api_error = false;

  const validationSchema = Yup.object().shape({
    goal: Yup.string().required("This field is required!"),
    prize: Yup.string().required("This field is required!"),
  });

  return (
    <Fragment>
      {modal.name === "video_modal" && (
        <div className={styles.background}>
          <div className={styles.wrapper}>
            <div className={styles.insideWrapper}>
              <div className={styles.title}>Add/Edit Video</div>
              <div className={styles.line} />
              <Formik
                validationSchema={validationSchema}
                initialValues={{
                  title: "",
                  description: "",
                }}
                onSubmit={(values) => {
                  setLoading(true);

                  setTimeout(() => {
                    setLoading(false);
                    setModal("");
                  }, 2000);
                }}
              >
                {({
                  errors,
                  touched,
                  handleSubmit,
                  handleChange,
                  handleBlur,
                  submitForm,
                }) => (
                  <Fragment>
                    <Form className={styles.form} onSubmit={handleSubmit}>
                      <div className={styles.fieldRow}>
                        <FieldInput
                          id="title"
                          type="text"
                          label="Title"
                          placeholder="Insert title"
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          showErrors
                          errors={errors.title}
                          touched={touched.title}
                          required
                        />
                      </div>
                      <div className={styles.fieldRow}>
                        <FieldInput
                          id="description"
                          type="area"
                          label="Description"
                          placeholder="Insert description"
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          showErrors
                          errors={errors.description}
                          touched={touched.description}
                          required
                        />
                      </div>
                      <div className={styles.fieldRow}>
                        <FieldInput
                          id="video"
                          type="upload"
                          label="Upload Video"
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          showErrors
                          required
                        />
                      </div>
                    </Form>
                    <div
                      className={styles.footer}
                      style={
                        api_error
                          ? { justifyContent: "space-between" }
                          : { justifyContent: "flex-end" }
                      }
                    >
                      {api_error && (
                        <div className={styles.errorMessage}>
                          <div className={styles.icon}>
                            <Icon image="alert-circle" />
                          </div>
                          <span>Something went wrong, check the fields.</span>
                        </div>
                      )}
                      <div className={styles.buttons}>
                        <button
                          className={styles.cancel}
                          onClick={() => setModal("")}
                        >
                          Cancel
                        </button>
                        <button className={styles.save} onClick={submitForm}>
                          {loading ? (
                            <img
                              src={Loader}
                              alt="Loader"
                              className={styles.loader}
                            />
                          ) : (
                            "Save"
                          )}
                        </button>
                      </div>
                    </div>
                  </Fragment>
                )}
              </Formik>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
}
